import React from "react";

export const CommonFieldsData = (data, supplierOpt, gateWayList) => {
  return [
    {
      type: "select",
      name: "name",
      value: data.name,
      label: "Supplier",
      required: true,
      options: supplierOpt || [],
    },
    {
      type: "text",
      name: "code",
      value: data.code,
      label: "Airline Code",
      placeholder: "Enter airline code i.e,6E,AI,ALL",
      required: true,
    },
    {
      type: "text",
      name: "fareType",
      value: data.fareType,
      label: "Fare Type",
      placeholder: "Enter fare type",
      required: true,
    },
    {
      type: "text",
      name: "airlineMarkup",
      value: data.airlineMarkup,
      label: "Airline Markup",
      placeholder: "Enter airline markup",
      required: false,
    },
    {
      type: "text",
      name: "fareTypeMarkup",
      value: data.fareTypeMarkup,
      label: "Fare Type Markup",
      placeholder: "Enter fare type markup",
      class: "mt-4",
      required: false,
    },
    {
      type: "text",
      name: "blockedAutoTicketAirline",
      value: data.blockedAutoTicketAirline,
      label: "Allow Auto Ticket Airline",
      placeholder: "Enter Allow Auto Ticket Airline",
      class: "mt-4",
      required: false,
    },
    {
      type: "text",
      name: "blockedAirport",
      value: data.blockedAirport,
      label: "Allow Airport",
      placeholder: "Enter Allow Airport",
      class: "mt-4",
      required: false,
    },
    // {
    //   type: "text",
    //   name: "airportMarkup",
    //   value: data.airportMarkup,
    //   label: "Airport Markup",
    //   placeholder: "Enter airport markup",
    //   class: "mt-4",
    // },
    {
      type: "number",
      name: "extraMarkup",
      value: data.extraMarkup,
      label: "Extra Markup",
      placeholder: "Enter blocked Airport",
      class: "mt-4",
      required: true,
    },
    {
      type: "select",
      name: "gateway",
      value: data.gateway,
      label: "Gateways",
      class: "mt-4",
      required: true,
      options: gateWayList || [],
    },
    {
      type: "select",
      name: "isHoldActive",
      value: data.isHoldActive,
      label: "Hold Status",
      class: "mt-4",
      required: true,
      options: [
        { name: "Active", value: true },
        { name: "Inactive", value: false },
      ],
    },
    {
      type: "select",
      name: "supStatus",
      value: data.supStatus,
      label: "Supplier Status",
      class: "mt-4",
      required: true,
      options: [
        { name: "Active", value: "Y" },
        { name: "Inactive", value: "N" },
      ],
    },
  ];
};
